"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Portal_1 = require("./Portal");
var react_focus_lock_1 = require("react-focus-lock");
var ESC_KEY = 27;
var BestModal = /** @class */ (function (_super) {
    __extends(BestModal, _super);
    function BestModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onKeyDown = function (e) {
            if (e.keyCode === ESC_KEY) {
                _this.props.onRequestClose(e);
            }
        };
        return _this;
    }
    BestModal.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.onKeyDown);
        this.props.appRoot.setAttribute('aria-hidden', 'true');
        this.previousFocusedElement = document.activeElement;
    };
    BestModal.prototype.componentWillUnmount = function () {
        var _this = this;
        document.removeEventListener('keydown', this.onKeyDown);
        this.props.appRoot.removeAttribute('aria-hidden');
        if (this.previousFocusedElement) {
            // Something inside <FocusLock /> is setting activeElement.
            // This overrides that behaviour.
            setTimeout(function () {
                if (_this.previousFocusedElement) {
                    _this.previousFocusedElement.focus();
                }
            }, 0);
        }
    };
    BestModal.prototype.render = function () {
        var _a = this.props, children = _a.children, onRequestClose = _a.onRequestClose, appRoot = _a.appRoot, disableFocusLock = _a.disableFocusLock, props = __rest(_a, ["children", "onRequestClose", "appRoot", "disableFocusLock"]);
        return (React.createElement(Portal_1.default, null,
            React.createElement("div", __assign({ "aria-modal": "true", role: "dialog" }, props),
                React.createElement(react_focus_lock_1.default, { disabled: disableFocusLock }, children))));
    };
    return BestModal;
}(React.Component));
exports.default = BestModal;
